import { CleaningStatus, CleaningType } from "./cleaningInfo"

/** 予約カレンダーから判定したゲストの滞在区分 */
export type GuestStayStatus =
    "vacant" | "checkin" | "checkout" | "checkoutAndCheckin" | "staying"

export interface OccupancyOperation {
    operationId: string
    kind: "cleaning" | "tour"
    status: CleaningStatus
    cleaningType?: CleaningType | null
    photoTourTitle?: string | null
    scheduleStart?: number | null
    scheduleEnd?: number | null
    /** 自社（所有・業者アサイン・委譲先）のオペレーションか */
    isOwn: boolean
    /** 現地に入る会社名 */
    companyName?: string | null
}

export interface ListingOccupancy {
    /** 共用部など物件に紐づかない清掃では null */
    guest: GuestStayStatus | null
    /** API が未対応のあいだは undefined が返る */
    hasEarlyCheckin?: boolean
    /** 同一物件・同日の自分以外の清掃・ツアー */
    operations: OccupancyOperation[]
}

export const guestStayStatusLabel: Record<GuestStayStatus, string> = {
    vacant: "空室",
    checkin: "チェックインあり",
    checkout: "チェックアウトあり",
    checkoutAndCheckin: "本日アウトイン",
    staying: "滞在中"
}

export const guestStayStatusColor: Record<GuestStayStatus, string> = {
    vacant: "#eceff1",
    checkin: "#fff176",
    checkout: "#90caf9",
    checkoutAndCheckin: "#ffb74d",
    staying: "#ef9a9a"
}

export const occupancyOperationStatusLabel: Record<CleaningStatus, string> = {
    prepared: "未着手",
    started: "作業中",
    finished: "作業完了",
    reported: "報告済み"
}
